export default "__VITE_ASSET__46e2b86f__"